import TemplePage from "./TemplePage";

export default TemplePage;
